import * as Yup from "yup";

export default function StringValidation(min, max) {
  return Yup.string()
    .min(min, `Must be between ${min} and ${max} characters`)
    .max(max, `Must be between ${min} and ${max} characters`)
    .required("Required");
}
